
@if (!isErrorPage()) {
<db-alert status="warning" design="notification" size="sm" class="w-100 m-0">
  {{ 'HEADER.warning' | translate }}
</db-alert>
}
